module.exports = __webpack_public_path__ + "static/img/blg-light-pop-up-bg.e66b81f0.png";